// extracted by mini-css-extract-plugin
export default {"wrapper":"MyJobs_wrapper__B9paH","head":"MyJobs_head__PxvU1","head_favourites":"MyJobs_head_favourites__Fd4KS"};